import React from 'react';
import { Box, Button, Card, CardActionArea, CardContent, Stack, Typography } from '@mui/material';
import { useLiveMatch } from '../LiveMatchContext.tsx';
import { Strategy } from '../liveMatchTypes.ts';

interface Props {
  onBack: () => void;
}

const OPTIONS: { value: Strategy; label: string; description: string }[] = [
  {
    value: 'BEST_OF_3',
    label: 'Al meglio di 3 set',
    description: 'Vince chi raggiunge prima 2 set. Set da 25 punti (3° set a 15).',
  },
  {
    value: 'BEST_OF_5',
    label: 'Al meglio di 5 set',
    description: 'Vince chi raggiunge prima 3 set. Set da 25 punti (5° set a 15).',
  },
];

export default function StrategySelectionStep({ onBack }: Props) {
  const { state, dispatch } = useLiveMatch();

  function select(strategy: Strategy) {
    dispatch({ type: 'SET_STRATEGY', payload: strategy });
  }

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" mb={3}>
        Formato della partita
      </Typography>

      <Stack spacing={2} sx={{ maxWidth: 480 }}>
        {OPTIONS.map((opt) => (
          <Card
            key={opt.value}
            variant="outlined"
            sx={{
              borderColor: state.strategy === opt.value ? 'primary.main' : 'divider',
              borderWidth: state.strategy === opt.value ? 2 : 1,
            }}
          >
            <CardActionArea onClick={() => select(opt.value)}>
              <CardContent>
                <Typography variant="subtitle1" fontWeight="bold">
                  {opt.label}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {opt.description}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Stack>

      <Box sx={{ mt: 3 }}>
        <Button onClick={onBack} color="inherit">
          ← Indietro
        </Button>
      </Box>
    </Box>
  );
}
